import axios from 'axios'
import _ from 'lodash'

// state
const state = {
	files: [], 					// all files belonging to job
	deleteFile: {}, 			// temporarily hold selected file to delete
	canUploadFile: false,
	selectedFile: {},			// track selection of uploaded files
	showUploadLoader: false,	// upload loader
	errorMsg: '',
	showErrorMsg: false,
	canSave: false,
	saveLoader: false,
	submitToServer: false,
	html: '',

	// non-logged
	alreadyUploaded: false,
	invalidToken: false,
	uploadSuccess: false,
	timeNotAllowed: false,
	guest: false,				// we'll use this to track non-logged user
	data: {},
	formData: {},
  attachTo: {}     // use it to attach upload to another model
}

const getters = {
	getSelectedFile(state){
		return state.selectedFile
	},
	getshowUploadLoader(state){
		return state.showUploadLoader
	},
	getshowErrorMsg(state){
		return state.showErrorMsg
	},
	geterrorMsg(state){
		return state.errorMsg
	},
	getdigitalFormData(state){
		return state.digitalFormData
	},
	getcanSave(state){
		return state.canSave
	},
	getsaveLoader(state){
		return state.saveLoader
	}
}


// mutations
const mutations = {
	SET_VARIABLE(state, {key, value}){
		eval('state.' + key + ' = value');
	},

	ADD_UPLOADED_FILE(state, {files}){
		state.files.push(files);
	},
}

// actions
const actions = {
	setVariable({commit}, {key, value}){
		commit('SET_VARIABLE', {key: key, value: value});
	},

	// get files
	getFiles({commit, state, dispatch, getters, rootState, rootGetters}){
		var header = rootState.auth.header;
		var client_request_id = rootState.requests.formData[0].client_request_id;
		var url = rootState.auth.l+'v1/translation-original-files?client_request_id='+client_request_id;

		axios.get(url,header)
			.then(response => {
				var files = response.data.data;
				commit('SET_VARIABLE', {key: 'files', value: files});
			}).catch((error) => {
				console.log(error);
			});
	},

	// upload documents
	uploadFile({commit, state, dispatch, rootState}, file){

    commit('SET_VARIABLE', {key: 'showUploadLoader', value: true});

    var header = rootState.auth.header;
		var client_request_id = rootState.requests.formData[0].client_request_id;
    var translation_original_file_id = state.attachTo.id;
    var file_name = state.attachTo.filename;
    var language = rootState.requests.formData[0].language;

    header = {
      ...header,
      headers: { ...(header.headers || {}), 'Content-Type': 'multipart/form-data' },
    };

    // get last element
    var cFile = rootState.requests.completedFiles;
    var result = cFile.filter( item => item.translation_original_file_id == translation_original_file_id);
		var version, lastItem;

    var lastItem = result[result.length - 1];
		if(result.length > 0){
			lastItem = result[result.length - 1];
			version = lastItem.version + 1;
		} else {
			version = 1;
		}

    let formData = new FormData();
    formData.append('file', file);
    formData.append('client_request_id', client_request_id);
    formData.append('file_name', file_name);
    formData.append('language', language);
    formData.append('translation_status_id', 2);  // default to 2 = Reviewing
    formData.append('translation_original_file_id', translation_original_file_id);
    formData.append('version', version);   // increase version number

    var url = rootState.auth.l+'v1/translation-completed-files';

    axios.post(url,formData,header)
    .then(response => {
      commit('SET_VARIABLE', {key: 'showUploadLoader', value: false});
      
			// show file successfull upload modal
			VueStore.dispatch('notify/setShowMessage', {key: 'showUploadFileSuccess', bool: true});

      var TRID = sessionStorage.getItem("TRID");

      $('#vendor-requests-table').DataTable().ajax.reload( function () {
        $('tr#' + TRID).click();
      });

    }).catch((error) => {
      console.log(error);
      commit('SET_VARIABLE', {key: 'showUploadLoader', value: false});
    });

	},
	// push selected file to delete to vuex
	pushToFileDelete({commit, state, dispatch, getters, rootState, rootGetters}, id){
		var files = state.files; // this will contain all files

		// filter by id
		var fileToDelete = files.filter( item => item.id == id);
		
		commit('SET_VARIABLE', {key: 'deleteFile', value: fileToDelete});
	},

	// delete file
	deleteFile({commit, state, dispatch, getters, rootState, rootGetters}){
		commit('SET_VARIABLE', {key: 'showUploadLoader', value: true});
		var header = rootState.auth.header;
		var deleteFile = state.deleteFile[0];
		var id = deleteFile.id;

		// update the server
		var url = rootState.auth.l+'v1/translation-original-files/'+id;
		axios.delete(url,header)
		.then(response => {
			// show modal for successful deletion
			VueStore.dispatch('notify/setShowMessage', {key: 'showDeleteFileSuccess', bool: true});

			// remove the deleted id from all job files
			var translationFiles = state.files;
			var updatedTranslationFiles = translationFiles.filter( item => item.id != id);
			commit('SET_VARIABLE', {key: 'files', value: updatedTranslationFiles});
			commit('SET_VARIABLE', {key: 'showUploadLoader', value: false});

			VueStore.dispatch('newRequest/removeFileIds', id);

		}).catch((error) => {
			console.log(error);
			commit('SET_VARIABLE', {key: 'showUploadLoader', value: false});
		});
	},

	// delete file sliently
	deleteFileSilently({commit, rootState}, files){
		var header = rootState.auth.header;

		//loop through files
		for(var i=0; i<files.length; i++){
			var url = rootState.auth.l+'v1/translation-original-files/'+files[i];

			axios.delete(url,header)
			.then(response => {
				console.log("files deleted", response)
			}).catch((error) => {
				console.log(error);
			});
		}

		// reset files state
		commit('SET_VARIABLE', {key: 'files', value: []});

	},
}

export default {
  namespaced: true,
	state,
	getters,
	mutations,
	actions
}